module.exports = __webpack_public_path__ + "static/media/Retro-Sprint-4-Audio-4.322394e4.mp3";